import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableAlignmentTop = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M2.5 1.5c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Z" fill={color} />
        <path d="M4.5 7.46 8 4m0 0 3.5 3.46M8 4v9" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default TableAlignmentTop
